export default __webpack_public_path__ + "static/media/cont_m_bg.6bb18c1d.png";